<div>
  <!-- First line -->
  <div class="mb-2 flex justify-between">
    <div class="text-label">{{ task().title }}</div>
    <div class="text-gray-500">{{ task().payerPortal }}</div>
  </div>
  <!-- Portal name -->
    <div class="mb-2">
      <div class="text-gray-500">{{ task().clientName }}</div>
      <div class="text-r1-blue-800">{{ task().accountNumber }}</div>
    </div>
  <!-- Second line -->
  <div class="flex justify-between">
    <div class="text-label text-red-600">{{ task().oppValue | currency }}</div>
    <ri-resolution-ui-task-date-label
      [task]="task()"
    ></ri-resolution-ui-task-date-label>
  </div>
</div>
